// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38MiM","colBig":"styles_colBig__1dB5f","colSmall":"styles_colSmall__3Z8zH","shopifyNameWrapper":"styles_shopifyNameWrapper__3QVlS"};